import { render, staticRenderFns } from "./BranchTeam.vue?vue&type=template&id=8f3c55e8&scoped=true"
import script from "./BranchTeam.vue?vue&type=script&lang=js"
export * from "./BranchTeam.vue?vue&type=script&lang=js"
import style0 from "./BranchTeam.vue?vue&type=style&index=0&id=8f3c55e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3c55e8",
  null
  
)

export default component.exports